module.exports = __webpack_public_path__ + "static/media/thumbs-up.8e6a5540.svg";